/**
 * Resource danh mục tài khoản kết chuyển
 * pntoan 15.5.2024
 */
export default {
  Title: 'Tài khoản ngầm định',
  RefType: 'Loại chứng từ',
  DefaultAccount: 'Tài khoản ngầm định',
  DefaultDebitAccount: 'TK nợ',
  DefaultDebitAccountTooltip: 'Tài khoản nợ',
  DefaultCreditAccount: 'TK có',
  DefaultCreditAccountTooltip: 'Tài khoản có',
  DefaultDebitAccountCategory: 'Nhóm TK nợ',
  DefaultDebitAccountCategoryTooltip: 'Nhóm tài khoản nợ',
  DefaultCreditAccountCategory: 'Nhóm TK có',
  DefaultCreditAccountCategoryTooltip: 'Nhóm tài khoản có',
};
